<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
    "adiantamento",
]);

const emits = defineEmits([
    "update:alteraAdiantamento",
]);

//==================================================================//
//===================== Altera Adiantamento ========================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

//==================================================================//
//=============== Ao Expandir Notas Fiscais Emitidas ===============//
//==================================================================//

const aoExpandirNotasFiscaisEmitidas = ()=>{

    alteraAdiantamento({
        aberto: !props?.adiantamento?.aberto,
    })

};

//==================================================================//
//============ Mostra Expandir NotasFiscais Emitidas ===============//
//==================================================================//

let mostraExpandirNotasFiscaisEmitidas = computed(()=>{

    if(props?.adiantamento?.notasFiscaisEmitidas?.length <= 0){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip
                    bottom
                >

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="mostraExpandirNotasFiscaisEmitidas"
                            class="mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoExpandirNotasFiscaisEmitidas"
                        >

                            <v-icon
                                v-if="props?.adiantamento?.aberto == false"
                                dark
                            >
                                mdi-chevron-down
                            </v-icon>

                            <v-icon
                                v-else
                                dark
                            >
                                mdi-chevron-up
                            </v-icon>

                        
                        </v-btn>

                    </template>

                    <span>Visualizar os Adiantamentos</span>

                </v-tooltip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cash-multiple
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >
                        {{props?.adiantamento?.codigo}}
                    </span>
                    

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.adiantamento?.origem}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.adiantamento?.status}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.adiantamento?.contaFinanceiraNome}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.adiantamento?.dataCriacao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.adiantamento?.valorOriginal)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.adiantamento?.valorRecebido)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.adiantamento?.valorParaReceber)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell--principal{
    border-left: 10px solid #1976d2;
    border-radius: 5px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

</style>
